import React, { useState } from "react";
import { Button, Modal, Form, Row, Col, Input } from "antd";
import { eContent } from "../../constant/field-names";
import { StyledTitle } from "../../../../../../components/styled-antd/Title";
import { StyledButton } from "../../../../../../components/styled-antd";
import { HiPencilSquare } from "react-icons/hi2";


export const EditModal = ({
  dataSource,
  setDataSource,
  index,
  parentValues,
}: any) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [form] = Form.useForm();

  const showModal = () => {
    form.resetFields();
    form.setFieldsValue(dataSource[index]);
    form.setFieldValue(eContent.department, parentValues?.eDepartment);
    setIsModalOpen(true);
  };
  const handleOk = async () => {
    // const validate = await form.validateFields();
    const values = form.getFieldsValue();
    let newDataSource = [...dataSource];
    newDataSource[index] = values;

    setDataSource(newDataSource);
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    form.resetFields();
    setIsModalOpen(false);
  };
  return (
    <>
      <Button onClick={showModal} className="mb-3">
        <HiPencilSquare size={20} className="cursor-pointer" color="#0ea5e9" />
      </Button>

      <Modal
        title="NHÂN SỰ ĐƯỢC THAY ĐỔI/BỔ SUNG KHÓA HỌC"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        width={"70%"}
      >
        <Form form={form}>
          <Row gutter={[32, 0]}>
            <Col span={12}>
              <StyledTitle level={5}>
                Nhân sự/ mã NV đã đăng ký{" "}
                <span className="text-danger">(*)</span>
              </StyledTitle>
              <Form.Item
                name={eContent.registerPersonel}
                rules={[
                  { required: true, message: "Nhân sự/ mã NV đã đăng ký" },
                ]}
              >
                <Input className="font-weight-normal" />
              </Form.Item>
            </Col>

            <Col span={12}>
              <StyledTitle level={5}>
                Nhân sự/ mã NV thay thế/ bổ sung *{" "}
                <span className="text-danger">(*)</span>
              </StyledTitle>
              <Form.Item
                name={eContent.replacePersonel}
                rules={[
                  {
                    required: true,
                    message: "Nhân sự/ mã NV thay thế/ bổ sung",
                  },
                ]}
              >
                <Input className="font-weight-normal" />
              </Form.Item>
            </Col>

            <Col span={12}>
              <StyledTitle level={5}>
                Cơ quan đơn vị <span className="text-danger">(*)</span>
              </StyledTitle>
              <Form.Item
                name={eContent.department}
                rules={[{ required: true, message: "Cơ quan đơn vị" }]}
              >
                <Input disabled />
              </Form.Item>
            </Col>

            <Col span={12}>
              <StyledTitle level={5}>Lí do thay đổi</StyledTitle>
              <Form.Item name={eContent.reason}>
                <Input className="font-weight-normal" />
              </Form.Item>
            </Col>

            <Col span={24}>
              <StyledTitle level={5}>Ghi chú</StyledTitle>
              <Form.Item name={eContent.note}>
                <Input className="font-weight-normal" />
              </Form.Item>
            </Col>

            <Col span={24}>
              <div className="flex-center">
                <StyledButton
                  bgColor="yellow"
                  type="primary"
                  htmlType="submit"
                  onClick={handleOk}
                >
                  Xác nhận
                </StyledButton>
              </div>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};
